import React from "react";
import { AnswerWrapper } from "./MultipleChoiceAnswerBlock.styled";

const MultipleChoiceOtherAnswerBlock = ({
  arrIndex,
  textAnswers,
  type,
  other,
  dependency,
}) => {
  const handleText = (e) => {
    let arrayCopy = JSON.parse(JSON.stringify(textAnswers));
    arrayCopy.splice(arrIndex, 1);
    let pos = arrayCopy.findIndex(
      (f) => f.toUpperCase().trim() == e.target.value.toUpperCase().trim()
    );
    if (pos == -1) {
      if (e.target.value.toUpperCase() == "OTHER") {
        e.target.value = "";
      }
    } else {
      e.target.value = "";
    }
    if (type == "radio" && dependency) {
      dependency
        .filter((f) => f.dependentAnswer === textAnswers[arrIndex])
        .map((q) => (q.dependentAnswer = e.target.value));
    }
    if (!other) {
      textAnswers[arrIndex] = e.target.value;
    }
  };

  return (
    <AnswerWrapper other={other} className="answer-wrapper-multichoice">
      <input
        type={type}
        name="answer"
        className={`answer-wrapper-multichoice-${type}`}
      />
      {other ? <label>Other:</label> : null}

      <input
        type="text"
        className={other ? "other" : "answer"}
        placeholder={other ? "Please Specify" : "Type an answer"}
        defaultValue={other ? "" : textAnswers[arrIndex]}
        onChange={(e) => handleText(e)}
      />
    </AnswerWrapper>
  );
};

export default MultipleChoiceOtherAnswerBlock;
